export default {
  id: "map-layers",
  title: "Map & layers",
  summary: "Move around the map, switch GIS and weather layers, use the time slider",
  minutes: 3,
  steps: [
    {
      title: "Map & layers",
      text: "This tour shows you how to move around the map and how to switch information layers on and off.",
    },
    {
      selector: ".leaflet-container",
      title: "The map",
      text: "<ul><li><b>Drag</b> to move the map.</li><li><b>Scroll</b> or pinch to zoom.</li><li><b>Click a vessel</b> to see its details.</li></ul>",
      side: "over",
    },
    {
      anchor: "drawer",
      title: "Side menu",
      text: "All tools open from this menu. Hover over an icon to see its name. Click an entry again to close its panel.",
      side: "right",
    },
    {
      anchor: "drawer-gis",
      skipIf: "gis-panel",
      click: true,
      title: "Open GIS Layers",
      text: "Click <b>GIS Layers</b>.",
      side: "right",
    },
    {
      anchor: "gis-layers",
      title: "Show map overlays",
      text: "Tick a box to show a layer on the map, e.g. <b>ECA Zones</b>, piracy zones, war risk zones or ports. The colour sample on the right shows how the layer looks on the map.",
      side: "right",
    },
    {
      anchor: "gis-visibility",
      title: "Hide all at once",
      text: "This switch hides all GIS layers at once. Your selection is kept, so you can switch them back on with one click.",
      side: "bottom",
    },
    {
      anchor: "drawer-weather",
      skipIf: "weather-panel",
      click: true,
      title: "Open Weather Forecast",
      text: "Click <b>Weather Forecast</b>.",
      side: "right",
    },
    {
      anchor: "weather-parameter",
      title: "Choose a weather parameter",
      text: "Select <b>Wind</b>, <b>Waves</b> or <b>Current</b>. Only one parameter is shown at a time. For wind you can switch between <b>Mean</b> and <b>Gusts</b>.",
      side: "right",
    },
    {
      anchor: "weather-legend",
      optional: true,
      wait: 3000,
      title: "Legend",
      text: "The legend explains the colours on the map. Click the unit next to it to change it.",
      side: "right",
    },
    {
      anchor: "timeslider",
      optional: true,
      wait: 3000,
      title: "Move through time",
      text: "The time slider controls the forecast time on the map. Drag the marker, use <b>±6 h</b>, press <b>play</b> to animate, or jump back to <b>now</b>. Routes and vessel positions follow the same time.",
      side: "top",
    },
    {
      anchor: "drawer-map",
      skipIf: "map-panel",
      click: true,
      title: "Open Map Settings",
      text: "Click <b>Map Settings</b>.",
      side: "right",
    },
    {
      anchor: "map-panel",
      title: "Map settings",
      text: "Here you can add helpers to the map, e.g. a minimap, a grid of latitude and longitude lines, the day/night border or a nautical mile scale.",
      side: "right",
    },
    {
      selector: ".leaflet-control-layers",
      optional: true,
      wait: 1000,
      title: "Sea marks",
      text: "Hover over this button and tick <b>OpenSeaMap</b> to show buoys, lights and other sea marks when you zoom in close.",
      side: "left",
    },
    {
      anchor: "help-button",
      title: "Need help again?",
      text: "You can start any tutorial again here at any time. The user manual is also linked here.",
      side: "bottom",
    },
  ],
}
